import languages from '@store/languages';
import {
  getJSON,
  getHrefParam,
  PASSPORT_HOST,
  HOST,
  ACTIVITY_HOST,
  HOME_HOST,
  post
} from '../ultile';

import ipCheck from '../ipCheck';

import dialog from './dialog';
import account from './account';
import services from './services';
import logoConfig from './logoConfig';
import support from './support';
import accountSetting from './accountSetting';
import findPassword from './findPassword';
import onestoreSubscribe from './onestoreSubscribe';
import tokenLogin from './tokenLogin';
import sdkSkin from '../sdkSkin';
import dma from '../dma';
import bridge from '../../utiles/bridge';

const CONFIG_ACTION = 'center/feature_status';
export const GET_CONFIG = 'getConfig';
export const GET_SERIAL_EXCHANGE = 'get_serial_exchange';
export const GET_GAME = 'getGame';
export const GET_MENU = 'getMenu';
export const CLICK_MENU = 'clickMenu';
export const GET_EXE_CLIENT_PAY = 'micro_game/dir_login';
export const SET_SHOW_CLOSE_ANI = 'setShowCloseAni';
export const SET_DYNAMIC_MENU = 'setDynamicMenu';
export const SET_DYNAMIC_AD = 'setDynamicAd';
export const SET_HAS_REPORT_SLIDER_AD = 'setHasReportSliderAd';
const UPDATE_RED_DOT = 'updateRedDot';
const SET_CONFIG = 'setConfig';
const SET_OPEN_EXCHANGE = 'setOpenExchange';
const SET_UNBING_STATE = 'setUnBindState';
const CONFIG_CODE = 1;
languages.init();

export default {
  strict: process.env.NODE_ENV !== 'production', // 在非生产环境下，使用严格模式
  state: {
    curLang: languages.getLanguage(),
    languages: languages.getAll(),
    hasRewardFunction: false,
    hasMigrateFunction: false,
    openExchange: false,
    unBindState: false,
    showCloseAni: false, // 关闭用户中心动画
    dynamicMenu: [], // 万花筒配置的菜单
    sliderAd: [], // 万花筒配置的轮播广告
    hasReportSliderAd: [], // 已经上报过的轮播广告
    hasAccountDelete: false // 是否显示删除账号入口
  },
  getters: {
    getExchangeState: state => state.openExchange
  },
  mutations: {
    [SET_HAS_REPORT_SLIDER_AD](state, activityId) {
      state.hasReportSliderAd.push(activityId);
    },
    [SET_SHOW_CLOSE_ANI](state, bool) {
      state.showCloseAni = bool;
    },
    [SET_CONFIG](state, config) {
      state.hasMigrateFunction = config.MIGRATE_CODE == CONFIG_CODE;
      state.hasRewardFunction = config.REWARD == CONFIG_CODE;
      state.hasAccountDelete = config.DESTROY_USER == CONFIG_CODE;
      let gameId = getHrefParam('gameId');
      let configStore = {
        [gameId]: {
          hasMigrateFunction: state.hasMigrateFunction,
          hasRewardFunction: state.hasRewardFunction
        }
      };
      localStorage.setItem('functionConfig', JSON.stringify(configStore));
    },
    [SET_OPEN_EXCHANGE](state, payload) {
      state.openExchange = payload;
    },
    [SET_UNBING_STATE](state, res) {
      // TODO：是否允许解绑
      // state.unBindState = true;
      state.unBindState = Boolean(res);
    },
    [SET_DYNAMIC_MENU](state, data) {
      if (data && data.length > 0) {
        const menuArr = [];
        for (let i = 0, len = data.length; i < len; i++) {
          const item = data[i];
          if (item.AD_TYPE != 4) {
            menuArr.push({
              id: item?.ID, // 按钮的ID，请求floatLayer/clickCallback使用
              activityId: item?.ACTIVITY_ID, // 万花筒活动ID，打点上报使用
              visible: item?.TITLE_TEXT ? true : false,
              iconName: '',
              iconSvg: item?.ICON_URL || '',
              menuText: item?.TITLE_TEXT || '',
              to: '',
              showDot: item?.IS_SHOW_RED,
              clickEvent: () => {
                const sdkMethodName =
                  item?.OPEN_TYPE == 0 ? 'openWebView' : 'openBrowser';
                if (item.OPEN_URL) {
                  bridge.callSdkMethod(sdkMethodName, {
                    url: item.OPEN_URL,
                    loginDir: 1,
                    appendParams: 1
                  });
                }
              }
            });
          }
        }
        state.dynamicMenu = menuArr;
      } else {
        state.dynamicMenu = [];
      }
    },
    [SET_DYNAMIC_AD](state, data) {
      if (data && data.length > 0) {
        const sliderAdArr = [];
        for (let i = 0, len = data.length; i < len; i++) {
          const item = data[i];
          if (item?.ICON_URL && item.AD_TYPE == 4) {
            sliderAdArr.push({
              id: item?.ID, // 按钮的ID，请求floatLayer/clickCallback使用
              activityId: item?.ACTIVITY_ID, // 万花筒活动ID，打点上报使用
              imgSrc: item?.ICON_URL,
              link: item?.OPEN_URL,
              openWebview: item?.OPEN_TYPE,
              showDot: item?.IS_SHOW_RED,
              color: item?.ROTATE_TITLE_COLOR || '',
              text: item?.TITLE_TEXT || ''
            });
          }
        }
        state.sliderAd = sliderAdArr;
      } else {
        state.sliderAd = [];
      }
    },
    [UPDATE_RED_DOT](state, id) {
      // 有红点是true，没有红点了是false，
      let boolHadNoClickMenu = false;
      let boolHadNoClickAd = false;

      // 检查菜单红点
      const menuIndex = state.dynamicMenu.findIndex(item => item.id === id);
      if (menuIndex !== -1) {
        state.dynamicMenu[menuIndex].showDot = false;
      }
      boolHadNoClickMenu = state.dynamicMenu.some(item => item.showDot);

      // 检查广告红点
      const adMenuIndex = state.sliderAd.findIndex(item => item.id === id);
      if (adMenuIndex !== -1) {
        state.sliderAd[adMenuIndex].showDot = false;
      }
      boolHadNoClickAd = state.sliderAd.some(item => item.showDot);

      // 其中之一有红点就告诉SDK有红点
      bridge.callSdkMethod('updateRedDot', {
        hasRedDot: boolHadNoClickMenu || boolHadNoClickAd ? 1 : 0 // 1表示有小红点，0表示没有
      });
    }
  },
  actions: {
    [CLICK_MENU]({ commit, state }, id) {
      const link = HOST + 'floatLayer/clickCallback';
      post(link, {
        id, // 按钮id
        loginAccount: getHrefParam('loginAccount') || getHrefParam('userName') // 账号
      }).then(({ errmsg, res }) => {
        if (errmsg) {
          console.error(errmsg);
        } else {
          commit(UPDATE_RED_DOT, id);
        }
      });
    },
    [GET_MENU]({ commit, state }) {
      const link = HOST + 'floatLayer/basic';
      post(link, {
        gameId: getHrefParam('gameId'), //游戏id
        loginAccount: getHrefParam('loginAccount') || getHrefParam('userName'), //账号
        uid: state.account.userId || getHrefParam('userId'), //用户id
        devicePlate: getHrefParam('devicePlate'), //设备类型，ios或android
        packageName: getHrefParam('packageName'), //包名
        cacheToken: getHrefParam('CacheToken') //iOS的SDK参数，透传过来CacheToken
      }).then(({ errmsg, res }) => {
        if (errmsg) {
          console.error(errmsg);
          resolve();
        } else {
          commit(SET_DYNAMIC_MENU, res?.data?.otherList || []);
          commit(SET_DYNAMIC_AD, res?.data?.rotateList || []);
          commit(UPDATE_RED_DOT, null);
        }
      });
      // TODO:DEV
      // commit(SET_DYNAMIC_MENU, [
      //   {
      //     ID: 101, // 按钮ID
      //     ACTIVITY_ID: 'test101', // 万花筒活动ID
      //     AD_TYPE: 1, //广告类型，1问卷，2攻略站，3邮箱收集，4轮播，5自定义广告
      //     OPEN_URL: `https://www.${window.atob('MzdnYW1lcy5jb20=')}`, // 打开链接
      //     OPEN_TYPE: 1, // 打开方式，0游戏内，1外跳浏览器
      //     ROTATE_TITLE_COLOR: '#000000', // 轮播广告标题颜色
      //     ICON_URL:
      //       '<?xml version="1.0" encoding="UTF-8"?><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="20" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M24 37V44V37Z" fill="none"/><path d="M24 37V44" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M36 24H44H36Z" fill="none"/><path d="M36 24H44" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4 24H11H4Z" fill="none"/><path d="M4 24H11" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M24 11V4V11Z" fill="none"/><path d="M24 11V4" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>', // icon地址,为空则根据AD_TYPE用默认icon
      //     TITLE_TEXT: '菜单1', // 标题文案
      //     IS_SHOW_RED: true // 是否显示小红点
      //   },
      //   {
      //     ID: 102, // 按钮ID
      //     ACTIVITY_ID: 'test102', // 万花筒活动ID
      //     AD_TYPE: 1, //广告类型，1问卷，2攻略站，3邮箱收集，4轮播，5自定义广告
      //     OPEN_URL: `https://www.${window.atob('MzdnYW1lcy5jb20=')}`, // 打开链接
      //     OPEN_TYPE: 2, // 打开方式，0游戏内，1外跳浏览器
      //     ROTATE_TITLE_COLOR: '#000000', // 轮播广告标题颜色
      //     ICON_URL:
      //       '<?xml version="1.0" encoding="UTF-8"?><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28 6H42V20" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M42 29.4737V39C42 40.6569 40.6569 42 39 42H9C7.34315 42 6 40.6569 6 39V9C6 7.34315 7.34315 6 9 6L18 6" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M25.7998 22.1999L41.0998 6.8999" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>', // icon地址,为空则根据AD_TYPE用默认icon
      //     TITLE_TEXT: '菜单2', // 标题文案
      //     IS_SHOW_RED: true // 是否显示小红点
      //   }
      // ]);
      // commit(SET_DYNAMIC_AD, [
      //   {
      //     ID: 201, // 按钮ID
      //     ACTIVITY_ID: 'test201', // 万花筒活动ID
      //     AD_TYPE: 4, //广告类型，1问卷，2攻略站，3邮箱收集，4轮播，5自定义广告
      //     OPEN_URL: `https://www.${window.atob('MzdnYW1lcy5jb20=')}`, // 打开链接
      //     OPEN_TYPE: 1, // 打开方式，0游戏内，1外跳浏览器
      //     ROTATE_TITLE_COLOR: '#000000', // 轮播广告标题颜色
      //     ICON_URL:
      //       'https://abres.octlib.com/site/dlssr/img/newslider-3.9176b5a.jpg', // icon地址,为空则根据AD_TYPE用默认icon
      //     TITLE_TEXT: '广告文案1', // 标题文案
      //     IS_SHOW_RED: true // 是否显示小红点
      //   },
      //   {
      //     ID: 202, // 按钮ID
      //     ACTIVITY_ID: 'test202', // 万花筒活动ID
      //     AD_TYPE: 4, //广告类型，1问卷，2攻略站，3邮箱收集，4轮播，5自定义广告
      //     OPEN_URL: `https://www.${window.atob('MzdnYW1lcy5jb20=')}`, // 打开链接
      //     OPEN_TYPE: 2, // 打开方式，0游戏内，1外跳浏览器
      //     ROTATE_TITLE_COLOR: '#000000', // 轮播广告标题颜色
      //     ICON_URL:
      //       'https://abres.octlib.com/site/dlssr/img/newslider-2.d1a5dc9.jpg', // icon地址,为空则根据AD_TYPE用默认icon
      //     TITLE_TEXT: '广告文案2', // 标题文案
      //     IS_SHOW_RED: true // 是否显示小红点
      //   }
      // ]);
      // commit(UPDATE_RED_DOT, null);
    },
    [GET_CONFIG]({ commit }) {
      getJSON(PASSPORT_HOST + CONFIG_ACTION, {
        gameId: getHrefParam('gameId'),
        packageName: getHrefParam('packageName'),
        packageVersion: getHrefParam('packageVersion'),
        devicePlate: getHrefParam('devicePlate'),
        userMode: getHrefParam('userMode'),
        language: getHrefParam('appLanguage') || getHrefParam('language') || ''
      }).then(({ errmsg, data }) => {
        if (!errmsg) {
          commit(SET_CONFIG, data);
        }
      });
    },
    [GET_SERIAL_EXCHANGE]({ commit }) {
      const packageName = getHrefParam('packageName');
      const link =
        ACTIVITY_HOST +
        `serial_exchange/app_reward_state?app_package_name=${packageName}`;
      return new Promise(resolve => {
        getJSON(link, {}).then(({ errmsg, res }) => {
          if (+res.result === 1) {
            commit(SET_OPEN_EXCHANGE, +res?.data?.REWARD_STATE);
          } else {
            commit(SET_OPEN_EXCHANGE, false);
          }
          resolve();
        });
      });
    },
    [GET_GAME]({ commit }) {
      getJSON(HOME_HOST + `ajax/get_game`, {
        gameID: getHrefParam('gameId')
      }).then(({ errmsg, res }) => {
        if (res.result == 1) {
          commit(SET_UNBING_STATE, +res.data.extra_info.ALLOW_UNBIND);
        }
      });
    }
  },
  modules: {
    dialog,
    account,
    ipCheck,
    services,
    logoConfig,
    accountSetting,
    findPassword,
    onestoreSubscribe,
    tokenLogin,
    support,
    sdkSkin,
    dma
  }
};
